function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 300 150",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 280,
    height: 130,
    rx: 30,
    ry: 30,
    style: {
      fill: "#DCECEE",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "50%",
    dominantBaseline: "middle",
    textAnchor: "middle",
    fontFamily: "CeraRoundPro, sans-serif",
    fontSize: 70,
    fill: "#14758E",
    stroke: "black",
    strokeWidth: 1,
    fontWeight: "bold",
    style: {
      letterSpacing: 2
    }
  }, "NUEVO"));
}

export default SvgNewIcon;